import { BodyMeasurement, Client, MeasurementKey } from '../types';

// Виды замеров тела: порядок и цвета общие для формы ввода, графика и истории
export const MEASUREMENT_KINDS: { key: MeasurementKey; label: string; short: string; color: string; defaultValue: number }[] = [
  { key: 'neck', label: 'Шея', short: 'Ш', color: '#3b82f6', defaultValue: 35 },
  { key: 'chest', label: 'Грудь', short: 'Г', color: '#10b981', defaultValue: 90 },
  { key: 'waist', label: 'Талия', short: 'Т', color: '#f59e0b', defaultValue: 75 },
  { key: 'hips', label: 'Бедра', short: 'Б', color: '#ef4444', defaultValue: 95 },
];

export const ALL_MEASUREMENT_KEYS: MeasurementKey[] = MEASUREMENT_KINDS.map(k => k.key);

// Отслеживаемые замеры клиента; не задано — все
export const getTrackedMeasurements = (client?: Pick<Client, 'tracked_measurements'> | null): MeasurementKey[] =>
  client?.tracked_measurements ?? ALL_MEASUREMENT_KEYS;

// «Т 75.0 · Б 95.0 см» по указанным замерам; если у записи нет ни одного
// из них — по всем, что в ней есть (чтобы строку можно было опознать)
export const formatMeasurementRecord = (m: BodyMeasurement, tracked: MeasurementKey[]): string => {
  const format = (keys: MeasurementKey[]) =>
    MEASUREMENT_KINDS.filter(k => keys.includes(k.key) && m[k.key] != null)
      .map(k => `${k.short} ${(m[k.key] as number).toFixed(1)}`)
      .join(' · ');
  const text = format(tracked) || format(ALL_MEASUREMENT_KEYS);
  return text ? `${text} см` : '—';
};
